import { PageRoutes } from 'platform-config/src/router/PageRoutes'
import type { RouteRecordRaw } from 'vue-router'

export const createInvestFinancialRouter = (): RouteRecordRaw[] => {
  return [
    {
      path: PageRoutes.Invest,
      component: () => import('../views/HomeView/InvestFinancial'),
    },
    {
      path: PageRoutes.InvestProductDetail,
      component: () => import('../views/FinancialDetail/FinancialDetail'),
    },
  ]
}
